import React from "react";

const DoneIcon = ({ className }) => (
  <svg
    className={className}
    width="11"
    height="8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.16718 7.66717C3.16652 7.66717 3.16585 7.66717 3.16518 7.66717C3.03185 7.6665 2.90451 7.61317 2.81051 7.51784L0.143848 4.80983C-0.0501524 4.61316 -0.0474835 4.29651 0.149183 4.10251C0.34585 3.90918 0.663181 3.91118 0.856514 4.10784L3.16919 6.45717L9.47985 0.1465C9.67518 -0.0488333 9.99185 -0.0488333 10.1872 0.1465C10.3825 0.341833 10.3825 0.658523 10.1872 0.853857L3.52052 7.52052C3.42718 7.61452 3.29985 7.66717 3.16718 7.66717Z"
      fill="white"
    />
  </svg>
);

export default DoneIcon;
